import React from 'react';
import { Tabs } from 'antd';
import Opening from './components/opening';
import Fps from './components/fps';
import SlaTransform from './components/slaTransform';
import './index.less';
import Render from './components/render';

const List: React.FC<{}> = () => {
  return (
    <div className="sla-list-box">
      <Tabs
        defaultActiveKey="2"
        destroyInactiveTabPane
        items={[
          {
            label: '转换',
            key: '1',
            children: <SlaTransform />,
          },
          {
            label: '打开',
            key: '2',
            children: <Opening />,
          },
          {
            label: 'FPS',
            key: '3',
            children: <Fps />,
          },
          {
            label: '渲染',
            key: '4',
            children: <Render />,
          },
        ]}
      />
    </div>
  );
};

export default List;
